<template>
  <div class="container">
    <el-image :src="imageUrl" fit="contain" @click="clickHandler">
      <div slot="error">
        <i class="el-icon-picture-outline"></i>
      </div>
    </el-image>

    <template v-for="marker in markers">
      <div class="marker-anchor"
        :style="markerStyle(marker)"
        :key="marker.label"
      >
        <base-icon
          iconClass="aim"
          className="marker"
          size="32px"
          @mouseover="(e) => showInfoWindow(e, marker)"
          @mouseout="(e) => hideInfoWindow(e, marker)"
        ></base-icon>
      </div>
    </template>

    <div ref="infoWindow" class="info-window" v-if="markerInfoContent"></div>
  </div>
</template>

<script>
export default {
  props: {
    imageUrl: {
      type: String,
    },
    markers: {
      type: Array,
    },
    markerInfoContent: {
      type: Function,
    },
  },
  data() {
    return {
      imageWidth: 0,
      imageHeight: 0,
    };
  },
  methods: {
    clickHandler(e) {
      const container = this.$el;
      const { clientWidth, clientHeight } = container;
      const left = e.offsetX / clientWidth;
      const top = e.offsetY / clientHeight;
      this.$emit('image-click', { top, left });
    },
    loadImage() {
      if (!this.imageUrl) return;
      const image = new Image();
      image.onload = () => {
        this.imageWidth = image.width;
        this.imageHeight = image.height;
      };
      image.src = this.imageUrl;
    },
    markerStyle(marker) {
      const { top, left } = marker;
      return {
        top: `${top * 100}%`,
        left: `${left * 100}%`,
      };
    },
    showInfoWindow(_e, marker) {
      const infoWindow = this.$refs.infoWindow;

      // 不需要消息窗
      if (!infoWindow) return;

      const { top, left } = this.markerStyle(marker);
      const infoContent = this.markerInfoContent(marker);
      infoWindow.innerHTML = '';
      infoWindow.appendChild(infoContent);
      infoWindow.style.bottom = `calc(100% - ${top} + 16px)`;
      infoWindow.style.left = `calc(${left} - 16px)`;
      infoWindow.classList.toggle('active', true);
    },
    hideInfoWindow() {
      // this.$refs.infoWindow.classList.toggle('active');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/var';

$marker-size: 32px;

.container {
  display: flex;
  position: relative;
}
.marker-anchor {
  position: absolute;
  color:  #1890ff;
  cursor: pointer;
  .marker {
    position: absolute;
    top: -($marker-size / 2);
    left: -($marker-size / 2);
  }
}

.info-window {
  display: none;
  position: absolute;
  min-width: 100px;
  max-width: 400px;
  padding: 5px;
  border: 1px solid  #1890ff;
  border-radius: 4px;
  background-color: #fff;
  color:  #1890ff;
  &.active {
    display: initial;
  }
}
</style>
